import './about.scss';
import Map_Dots from './map';

const map_el = document.querySelector('.about_map')

init();
function init(){

    if( !map_el ) return;
    
    const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
                observer.unobserve(map_el)
                init_dots();
			}
		});
	}, { threshold: .7 });

    observer.observe(map_el)
}

function init_dots(){

    const map_dots = new Map_Dots(map_el, {
        width: 697,
        height: 655,
    });

    const offices = [[681.5,329.5],[636.5,416.5],[561.5,519.5]]

    map_dots.load(offices, {
        dot_class: 'dot_office',
        interval: 200,
        before_show: (dot)=>{
            dot.style.opacity = 0;
            dot.style.transform = 'translateY(-20px)';

            setTimeout(()=>{
                dot.style.transition = 'opacity .2s ease, transform .4s ease';
            }, 1)
        },
        on_show: (dot)=>{
            dot.style.opacity = 1;
            dot.style.transform = 'translateY(0)';
        }
    });

    const regions = [[309.5,35.5],[553.5,110.5],[578.5,158.5],[601.5,171.5],[613.5,189.5],[603.5,210.5],[637.5,230.5],[663.5,253.5],[671.5,264.5],[676.5,279.5],[661.5,274.5],[658.5,291.5],[678.5,294.5],[685.5,306.5],[681.5,316.5],[672.5,305.5],[657.5,305.5],[665.5,317.5],[682.5,331.5],[668.5,328.5],[678.5,345.5],[664.5,341.5],[680.5,359.5],[680.5,359.5],[653.5,354.5],[653.5,354.5],[650.5,375.5],[666.5,393.5],[659.5,403.5],[651.5,412.5],[648.5,423.5],[648.5,423.5],[641.5,434.5],[636.5,448.5],[629.5,459.5],[636.5,404.5],[623.5,418.5],[623.5,431.5],[619.5,443.5],[619.5,443.5],[611.5,394.5],[588.5,517.5],[572.5,526.5],[549.5,523.5],[545.5,507.5],[532.5,516.5],[532.5,516.5],[555.5,493.5],[575.5,482.5],[575.5,482.5],[558.5,473.5],[558.5,453.5],[531.5,499.5],[535.5,489.5],[541.5,477.5],[496.5,527.5],[503.5,507.5],[494.5,492.5],[494.5,492.5],[479.5,502.5],[523.5,434.5],[523.5,434.5],[494.5,396.5],[444.5,463.5],[447.5,448.5],[433.5,450.5],[439.5,436.5],[423.5,414.5],[585.5,598.5],[571.5,600.5],[45.5,402.5],[47.5,384.5],[38.5,371.5]];

    setTimeout(()=>{

        map_dots.load(regions, {
            dot_class: 'dot_region',
            interval: 60,
            before_show: (dot)=>{
                dot.style.transform = 'scale(0)';

                setTimeout(()=>{
                    dot.style.transition = 'transform .1s ease';
                }, 1)
            },
            on_show: (dot)=>{
                dot.style.transform = 'scale(1)';
            }
        });

    }, 500)
}